<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-card class="pa-8">
      <v-card-title class="justify-center my-2 text-h5">
        {{ localSignStatus === '簽到' ? '批次簽到' : '批次簽退' }}
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <template v-if="!isViewOnly">
            <v-col cols="12">
              <v-select
                dense
                outlined
                :items="select_item"
                v-model="localSignStatus"
                :value="getSignItemValue(localSignStatus)"
                class="pa-2"
                hide-details
                @change="onStatusChange"
                label="選擇動作"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                dense
                outlined
                :items="filteredCaseList"
                item-text="name"
                item-value="case_num"
                v-model="localSelectedCases"
                label="選擇個案"
                multiple
                chips
                clearable
                class="pa-2"
                hide-details
                no-data-text="無可進行簽到退之個案"
              ></v-select>
            </v-col>
          </template>

          <!-- isViewOnly = true 時，直接顯示「已選個案名稱」 -->
          <template v-else>
            <v-col cols="12">
              <v-chip-group multiple column class="pa-2">
                <v-chip
                  v-for="(name, idx) in bulkedName"
                  :key="idx"
                  class="ma-1"
                  color="#BFECFF"
                  text-color="black"
                >
                  {{ name }}
                </v-chip>
                <!-- 若批次清單為空，可顯示提示 -->
                <div v-if="!bulkedName.length" class="text-caption grey--text">無已選個案</div>
              </v-chip-group>
            </v-col>
          </template>
          <v-col cols="12">
            <v-text-field
              dense
              outlined
              label="選擇日期"
              v-model="localDate"
              type="date"
              :rules="dateRules"
              class="my-2 pa-2"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row dense>
              <v-col cols="6">
                <v-select
                  dense
                  outlined
                  :items="hours"
                  v-model="selectedHour"
                  label="時"
                  class="my-2 px-2"
                  hide-details
                  @change="updateTime"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  dense
                  outlined
                  :items="minutes"
                  v-model="selectedMinute"
                  label="分"
                  class="my-2 px-2"
                  hide-details
                  @change="updateTime"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row dense class="justify-space-around">
          <v-btn text color="red" @click="closeDialog">取消</v-btn>
          <v-btn text color="blue" @click="onCheck">確認</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import qs from 'qs'
export default {
  name: 'SignDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    attendanceList: {
      type: Array,
    },
    bulkedId: {
      type: Array,
    },
    bulkedName: {
      type: Array,
    },
    staffId: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
    time: {
      type: String,
      default: () => moment().format('HH:mm'),
    },
    status: {
      type: String,
    },
    isViewOnly: {
      type: Boolean,
    },
  },
  data() {
    return {
      // 使用 local data 作雙向綁定
      localDate: this.date,
      localTime: this.time,
      localSignStatus: this.status,
      localSelectedCases: [],
      dateRules: [(v) => !!v || '此欄位不可為空'],
      timeRules: [(v) => !!v || '此欄位不可為空'],
      select_item: ['簽到', '簽退'],
      hours: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')),
      minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')),
      selectedHour: '12',
      selectedMinute: '00',
    }
  },
  computed: {
    dialog: {
      get() {
        console.log(this.attendanceList)
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    filteredCaseList() {
      if (this.localSignStatus === '簽到') {
        return this.attendanceList.filter(
          (item) =>
            (item.has_written === false && item.completed === false) ||
            (item.has_written === true && item.completed === true)
        )
      } else {
        return this.attendanceList.filter(
          (item) => item.has_written === true && item.completed === false
        )
      }
    },
  },
  methods: {
    getSignItemValue(item) {
      return item === '簽到' ? 'check_in' : 'check_out'
    },
    onStatusChange() {
      this.localSelectedCases = []
    },
    updateTime() {
      this.localTime = `${this.selectedHour}:${this.selectedMinute}`
    },
    initializeTimeSelector() {
      if (this.localTime) {
        const time = moment(this.localTime, ['HH:mm', 'h:mm A', 'h:mm']).format('HH:mm')
        const [hour, minute] = time.split(':')
        this.selectedHour = hour
        this.selectedMinute = minute
        this.localTime = time
      } else {
        const now = moment()
        this.selectedHour = now.format('HH')
        this.selectedMinute = now.format('mm')
        this.localTime = `${this.selectedHour}:${this.selectedMinute}`
      }
    },
    closeDialog() {
      this.$emit('close_dialog')
    },
    async onCheck() {
      if (this.localSelectedCases.length === 0) {
        alert('請至少選擇一個個案')
        return
      }
      const sign_action = this.localSignStatus === '簽到' ? 'check_in' : 'check_out'
      const formattedTime = moment(`${this.localDate}T${this.localTime}`).format()
      const data = JSON.stringify({
        cases: this.localSelectedCases,
        datetime: formattedTime,
        action: sign_action,
      })
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: '/api/attendance/bulk_check',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
      }
      try {
        const res = await axios.request(config)
        this.$emit('get_list')
      } catch (error) {
        alert(error.response.data.data)
      }
      this.closeDialog()
    },
  },
  mounted() {
    this.initializeTimeSelector()
  },
  watch: {
    date(newVal) {
      this.localDate = newVal
    },
    time(newVal) {
      if (newVal) {
        const time = moment(newVal, ['HH:mm', 'h:mm A', 'h:mm']).format('HH:mm')
        const [hour, minute] = time.split(':')
        this.selectedHour = hour
        this.selectedMinute = minute
        this.localTime = time
      }
    },
    status(newVal) {
      this.localSignStatus = newVal
    },
    value(newVal) {
      if (newVal) {
        this.localSelectedCases = [...this.bulkedId]
        this.initializeTimeSelector()
      } else {
        this.localDate = this.date
        this.localSignStatus = this.status
        this.localSelectedCases = []
      }
    },
  },
}
</script>

<style scoped>
.hover-effect:hover {
  cursor: pointer;
  color: #4477ce;
}
.hover-add:hover {
  cursor: pointer;
  color: #258525;
}
</style>
